export const INDUSTRY_TYPES = {
  auto: 'auto',
  rv: 'rv',
  industrial: 'industrial',
  motorcycle: 'motorcycle',
} as const;

export const DISCOUNT_FIXED = 'fixed' as const;
export const DISCOUNT_PERCENT = 'percent' as const;

export const CHARGE_FIXED = 'fixed' as const;
export const CHARGE_PERCENT = 'percent' as const;

export const REPAIR_ORDER_MEDIA_TYPE = {
  image: 'IMAGE',
  video: 'VIDEO',
} as const;

export const PAYMENT_VALIDATION_WARNING_STATES = ['Paid', 'Refunded', 'Confirmed'] as const;

export const SCHEDULER_SCREENS = {
  PHONE_INPUT: 'PHONE_INPUT',
  VEHICLE_SELECT: 'VEHICLE_SELECT',
  SERVICES_SELECT: 'SERVICES_SELECT',
  TRANSPORTATION: 'TRANSPORTATION',
  TIME_SELECT: 'TIME_SELECT',
  REVIEW: 'REVIEW',
  CONFIRMATION: 'CONFIRMATION',
} as const;
